module.exports = __webpack_public_path__ + "554c2ac6bf0924e9d3a8ef9c24973781.png";